<template>
  <div class="list-poi rounded-4 overflow-hidden relative">
    <div class="absolute top-0 bottom-0 left-0 right-0 poi-gradient">
      <img v-if="getBackgroundUrl" loading="lazy" :src="getBackgroundUrl" class="w-full h-full object-cover"/>
    </div>
    <div class="relative flex gap-16 grow w-full h-full justify-between items-end p-16 z-2" v-touch:tap="onPOIClick()">
      <div class="flex flex-col items-start">
        <label class="poi-name text-30 text-white font-black" v-html="poi.getName(language)"></label>
        <WFTranslate v-if="poi.getFloor()" k="floor" class="px-10 py-2 bg-active rounded-sm text-16" :params="[floorName]"></WFTranslate>
      </div>
      <div>
        <QR :poi="poi"></QR>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { WFTranslate } from "@3dwayfinder/wayfinder-vue-components";
import QR from "./QR.vue";

export default {
  components: {
    WFTranslate,
    QR
  },
  computed: {
    ...mapState("wf", ["language"]),
    getBackgroundUrl () {
      if (this.poi && this.poi.getAttribute("bg")) {
        let bg = this.poi.getAttribute("bg");

        return bg.value;
      }

      return false;
    },
    floorName () {
      if ( this.poi.getFloor() &&  this.poi.getFloor().getName) {
        return this.poi.getFloor().getName(this.language);
      }

      return '';
      
    }
  },
  props: {
    poi: {
      default: null,
      type: Object,
    },
  },
  methods: {
    onPOIClick() {
      return () => {
        this.$emit("onPOIClick", this.poi);
      };
    },
    getFirstGroup(poi) {
      if (typeof poi === "object") {
        return poi.getGroupNames().length > 0 ? poi.getGroupNames()[0] : "";
      }

      return "";
    },
    showPath() {
      return () => {
        if (this.poi) {
          this.$wayfinder.showPath(this.poi.getNode(), this.poi);
        }
      };
    },
    isImage () {
            if(this.poi) {
                if (this.poi.getIconUrl() != null && this.poi.getIconUrl().length > 0) return "image-logo";
            }
			
			return "image-none";
		},
  },
};
</script>

<style lang="postcss">
.list-poi {
  height: 34rem;

  .poi-gradient {
    &::after {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      content: '';
      display: block;
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0) 100%);
    }
    
  }

  .wf-poi {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 1.6rem;
  }

  .wf-poi-image {
    width: 5.6rem;
    height: 3.2rem;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }

  .group-label {
    background-color: var(--th-neutral);
  }

  .poi-name {
    text-align: left;
  }

  .image-none {
      display: none;
  }
}
</style>
